/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AsAssistantDraftDto } from '../models/as-assistant-draft-dto';
import { asControllerCreateChecklistItem } from '../fn/as/as-controller-create-checklist-item';
import { AsControllerCreateChecklistItem$Params } from '../fn/as/as-controller-create-checklist-item';
import { asControllerCreateClientTicket } from '../fn/as/as-controller-create-client-ticket';
import { AsControllerCreateClientTicket$Params } from '../fn/as/as-controller-create-client-ticket';
import { asControllerCreateVendorSymptom } from '../fn/as/as-controller-create-vendor-symptom';
import { AsControllerCreateVendorSymptom$Params } from '../fn/as/as-controller-create-vendor-symptom';
import { asControllerDeleteChecklist } from '../fn/as/as-controller-delete-checklist';
import { AsControllerDeleteChecklist$Params } from '../fn/as/as-controller-delete-checklist';
import { asControllerDeleteChecklistItem } from '../fn/as/as-controller-delete-checklist-item';
import { AsControllerDeleteChecklistItem$Params } from '../fn/as/as-controller-delete-checklist-item';
import { asControllerDeleteVendorSymptom } from '../fn/as/as-controller-delete-vendor-symptom';
import { AsControllerDeleteVendorSymptom$Params } from '../fn/as/as-controller-delete-vendor-symptom';
import { asControllerDeleteVendorTicket } from '../fn/as/as-controller-delete-vendor-ticket';
import { AsControllerDeleteVendorTicket$Params } from '../fn/as/as-controller-delete-vendor-ticket';
import { asControllerGenerateClientAssistantDraft } from '../fn/as/as-controller-generate-client-assistant-draft';
import { AsControllerGenerateClientAssistantDraft$Params } from '../fn/as/as-controller-generate-client-assistant-draft';
import { asControllerGetChecklistItems } from '../fn/as/as-controller-get-checklist-items';
import { AsControllerGetChecklistItems$Params } from '../fn/as/as-controller-get-checklist-items';
import { asControllerGetClientTicketDetail } from '../fn/as/as-controller-get-client-ticket-detail';
import { AsControllerGetClientTicketDetail$Params } from '../fn/as/as-controller-get-client-ticket-detail';
import { asControllerGetClientTickets } from '../fn/as/as-controller-get-client-tickets';
import { AsControllerGetClientTickets$Params } from '../fn/as/as-controller-get-client-tickets';
import { asControllerGetClientVisibleCheckItems } from '../fn/as/as-controller-get-client-visible-check-items';
import { AsControllerGetClientVisibleCheckItems$Params } from '../fn/as/as-controller-get-client-visible-check-items';
import { asControllerGetClientVisibleSymptoms } from '../fn/as/as-controller-get-client-visible-symptoms';
import { AsControllerGetClientVisibleSymptoms$Params } from '../fn/as/as-controller-get-client-visible-symptoms';
import { asControllerGetVendorPendingCount } from '../fn/as/as-controller-get-vendor-pending-count';
import { AsControllerGetVendorPendingCount$Params } from '../fn/as/as-controller-get-vendor-pending-count';
import { asControllerGetVendorSymptoms } from '../fn/as/as-controller-get-vendor-symptoms';
import { AsControllerGetVendorSymptoms$Params } from '../fn/as/as-controller-get-vendor-symptoms';
import { asControllerGetVendorTicketDetail } from '../fn/as/as-controller-get-vendor-ticket-detail';
import { AsControllerGetVendorTicketDetail$Params } from '../fn/as/as-controller-get-vendor-ticket-detail';
import { asControllerGetVendorTicketLogs } from '../fn/as/as-controller-get-vendor-ticket-logs';
import { AsControllerGetVendorTicketLogs$Params } from '../fn/as/as-controller-get-vendor-ticket-logs';
import { asControllerGetVendorTickets } from '../fn/as/as-controller-get-vendor-tickets';
import { AsControllerGetVendorTickets$Params } from '../fn/as/as-controller-get-vendor-tickets';
import { asControllerGetVendorWarning } from '../fn/as/as-controller-get-vendor-warning';
import { AsControllerGetVendorWarning$Params } from '../fn/as/as-controller-get-vendor-warning';
import { asControllerGetVendorWorkspaceTickets } from '../fn/as/as-controller-get-vendor-workspace-tickets';
import { AsControllerGetVendorWorkspaceTickets$Params } from '../fn/as/as-controller-get-vendor-workspace-tickets';
import { asControllerReorderChecklistItems } from '../fn/as/as-controller-reorder-checklist-items';
import { AsControllerReorderChecklistItems$Params } from '../fn/as/as-controller-reorder-checklist-items';
import { asControllerUpdateChecklistItem } from '../fn/as/as-controller-update-checklist-item';
import { AsControllerUpdateChecklistItem$Params } from '../fn/as/as-controller-update-checklist-item';
import { asControllerUpdateVendorMemo } from '../fn/as/as-controller-update-vendor-memo';
import { AsControllerUpdateVendorMemo$Params } from '../fn/as/as-controller-update-vendor-memo';
import { asControllerUpdateVendorResult } from '../fn/as/as-controller-update-vendor-result';
import { AsControllerUpdateVendorResult$Params } from '../fn/as/as-controller-update-vendor-result';
import { asControllerUpdateVendorStatus } from '../fn/as/as-controller-update-vendor-status';
import { AsControllerUpdateVendorStatus$Params } from '../fn/as/as-controller-update-vendor-status';
import { asControllerUpdateVendorSymptom } from '../fn/as/as-controller-update-vendor-symptom';
import { AsControllerUpdateVendorSymptom$Params } from '../fn/as/as-controller-update-vendor-symptom';
import { asControllerUpsertChecklist } from '../fn/as/as-controller-upsert-checklist';
import { AsControllerUpsertChecklist$Params } from '../fn/as/as-controller-upsert-checklist';
import { AsTicketDto } from '../models/as-ticket-dto';
import { AsTicketLogDto } from '../models/as-ticket-log-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { VendorCheckItemDto } from '../models/vendor-check-item-dto';
import { VendorChecklistDto } from '../models/vendor-checklist-dto';
import { VendorSymptomDto } from '../models/vendor-symptom-dto';

@Injectable({ providedIn: 'root' })
export class AsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `asControllerGetClientTickets()` */
  static readonly AsControllerGetClientTicketsPath = '/api/v1/as/client/{clientWorkspaceId}/tickets';

  /**
   * 고객사 A/S 티켓 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerGetClientTickets()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerGetClientTickets$Response(params: AsControllerGetClientTickets$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AsTicketDto>>> {
    return asControllerGetClientTickets(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 A/S 티켓 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerGetClientTickets$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerGetClientTickets(params: AsControllerGetClientTickets$Params, context?: HttpContext): Observable<Array<AsTicketDto>> {
    return this.asControllerGetClientTickets$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AsTicketDto>>): Array<AsTicketDto> => r.body)
    );
  }

  /** Path part for operation `asControllerCreateClientTicket()` */
  static readonly AsControllerCreateClientTicketPath = '/api/v1/as/client/{clientWorkspaceId}/tickets';

  /**
   * 고객사 A/S 티켓 접수.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerCreateClientTicket()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  asControllerCreateClientTicket$Response(params: AsControllerCreateClientTicket$Params, context?: HttpContext): Observable<StrictHttpResponse<AsTicketDto>> {
    return asControllerCreateClientTicket(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 A/S 티켓 접수.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerCreateClientTicket$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  asControllerCreateClientTicket(params: AsControllerCreateClientTicket$Params, context?: HttpContext): Observable<AsTicketDto> {
    return this.asControllerCreateClientTicket$Response(params, context).pipe(
      map((r: StrictHttpResponse<AsTicketDto>): AsTicketDto => r.body)
    );
  }

  /** Path part for operation `asControllerGetClientTicketDetail()` */
  static readonly AsControllerGetClientTicketDetailPath = '/api/v1/as/client/{clientWorkspaceId}/tickets/{ticketId}';

  /**
   * 고객사 A/S 티켓 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerGetClientTicketDetail()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerGetClientTicketDetail$Response(params: AsControllerGetClientTicketDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<AsTicketDto>> {
    return asControllerGetClientTicketDetail(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 A/S 티켓 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerGetClientTicketDetail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerGetClientTicketDetail(params: AsControllerGetClientTicketDetail$Params, context?: HttpContext): Observable<AsTicketDto> {
    return this.asControllerGetClientTicketDetail$Response(params, context).pipe(
      map((r: StrictHttpResponse<AsTicketDto>): AsTicketDto => r.body)
    );
  }

  /** Path part for operation `asControllerGetClientVisibleSymptoms()` */
  static readonly AsControllerGetClientVisibleSymptomsPath = '/api/v1/as/client/{clientWorkspaceId}/symptoms';

  /**
   * 고객사 노출 증상 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerGetClientVisibleSymptoms()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerGetClientVisibleSymptoms$Response(params: AsControllerGetClientVisibleSymptoms$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorSymptomDto>>> {
    return asControllerGetClientVisibleSymptoms(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 노출 증상 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerGetClientVisibleSymptoms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerGetClientVisibleSymptoms(params: AsControllerGetClientVisibleSymptoms$Params, context?: HttpContext): Observable<Array<VendorSymptomDto>> {
    return this.asControllerGetClientVisibleSymptoms$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VendorSymptomDto>>): Array<VendorSymptomDto> => r.body)
    );
  }

  /** Path part for operation `asControllerGetClientVisibleCheckItems()` */
  static readonly AsControllerGetClientVisibleCheckItemsPath = '/api/v1/as/client/{clientWorkspaceId}/symptoms/{symptomId}/check-items';

  /**
   * 고객사 노출 체크항목 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerGetClientVisibleCheckItems()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerGetClientVisibleCheckItems$Response(params: AsControllerGetClientVisibleCheckItems$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorCheckItemDto>>> {
    return asControllerGetClientVisibleCheckItems(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 노출 체크항목 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerGetClientVisibleCheckItems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerGetClientVisibleCheckItems(params: AsControllerGetClientVisibleCheckItems$Params, context?: HttpContext): Observable<Array<VendorCheckItemDto>> {
    return this.asControllerGetClientVisibleCheckItems$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VendorCheckItemDto>>): Array<VendorCheckItemDto> => r.body)
    );
  }

  /** Path part for operation `asControllerGenerateClientAssistantDraft()` */
  static readonly AsControllerGenerateClientAssistantDraftPath = '/api/v1/as/client/{clientWorkspaceId}/assistant/draft';

  /**
   * 고객사 A/S 어시스턴트 접수 초안 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerGenerateClientAssistantDraft()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  asControllerGenerateClientAssistantDraft$Response(params: AsControllerGenerateClientAssistantDraft$Params, context?: HttpContext): Observable<StrictHttpResponse<AsAssistantDraftDto>> {
    return asControllerGenerateClientAssistantDraft(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 A/S 어시스턴트 접수 초안 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerGenerateClientAssistantDraft$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  asControllerGenerateClientAssistantDraft(params: AsControllerGenerateClientAssistantDraft$Params, context?: HttpContext): Observable<AsAssistantDraftDto> {
    return this.asControllerGenerateClientAssistantDraft$Response(params, context).pipe(
      map((r: StrictHttpResponse<AsAssistantDraftDto>): AsAssistantDraftDto => r.body)
    );
  }

  /** Path part for operation `asControllerGetVendorTickets()` */
  static readonly AsControllerGetVendorTicketsPath = '/api/v1/as/vendor/{clientWorkspaceId}/tickets';

  /**
   * 입점사 A/S 티켓 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerGetVendorTickets()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerGetVendorTickets$Response(params: AsControllerGetVendorTickets$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return asControllerGetVendorTickets(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 A/S 티켓 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerGetVendorTickets$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerGetVendorTickets(params: AsControllerGetVendorTickets$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.asControllerGetVendorTickets$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `asControllerGetVendorWorkspaceTickets()` */
  static readonly AsControllerGetVendorWorkspaceTicketsPath = '/api/v1/as/vendor-workspace/{vendorWorkspaceId}/tickets';

  /**
   * 입점사 기준 A/S 티켓 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerGetVendorWorkspaceTickets()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerGetVendorWorkspaceTickets$Response(params: AsControllerGetVendorWorkspaceTickets$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return asControllerGetVendorWorkspaceTickets(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 기준 A/S 티켓 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerGetVendorWorkspaceTickets$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerGetVendorWorkspaceTickets(params: AsControllerGetVendorWorkspaceTickets$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.asControllerGetVendorWorkspaceTickets$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `asControllerGetVendorTicketDetail()` */
  static readonly AsControllerGetVendorTicketDetailPath = '/api/v1/as/vendor/{clientWorkspaceId}/tickets/{ticketId}';

  /**
   * 입점사 A/S 티켓 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerGetVendorTicketDetail()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerGetVendorTicketDetail$Response(params: AsControllerGetVendorTicketDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<AsTicketDto>> {
    return asControllerGetVendorTicketDetail(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 A/S 티켓 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerGetVendorTicketDetail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerGetVendorTicketDetail(params: AsControllerGetVendorTicketDetail$Params, context?: HttpContext): Observable<AsTicketDto> {
    return this.asControllerGetVendorTicketDetail$Response(params, context).pipe(
      map((r: StrictHttpResponse<AsTicketDto>): AsTicketDto => r.body)
    );
  }

  /** Path part for operation `asControllerDeleteVendorTicket()` */
  static readonly AsControllerDeleteVendorTicketPath = '/api/v1/as/vendor/{clientWorkspaceId}/tickets/{ticketId}';

  /**
   * 입점사 A/S 티켓 삭제(소프트).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerDeleteVendorTicket()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerDeleteVendorTicket$Response(params: AsControllerDeleteVendorTicket$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return asControllerDeleteVendorTicket(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 A/S 티켓 삭제(소프트).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerDeleteVendorTicket$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerDeleteVendorTicket(params: AsControllerDeleteVendorTicket$Params, context?: HttpContext): Observable<boolean> {
    return this.asControllerDeleteVendorTicket$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `asControllerUpdateVendorStatus()` */
  static readonly AsControllerUpdateVendorStatusPath = '/api/v1/as/vendor/{clientWorkspaceId}/tickets/{ticketId}/status';

  /**
   * 입점사 A/S 티켓 상태 변경.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerUpdateVendorStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  asControllerUpdateVendorStatus$Response(params: AsControllerUpdateVendorStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<AsTicketDto>> {
    return asControllerUpdateVendorStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 A/S 티켓 상태 변경.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerUpdateVendorStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  asControllerUpdateVendorStatus(params: AsControllerUpdateVendorStatus$Params, context?: HttpContext): Observable<AsTicketDto> {
    return this.asControllerUpdateVendorStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<AsTicketDto>): AsTicketDto => r.body)
    );
  }

  /** Path part for operation `asControllerUpdateVendorMemo()` */
  static readonly AsControllerUpdateVendorMemoPath = '/api/v1/as/vendor/{clientWorkspaceId}/tickets/{ticketId}/memo';

  /**
   * 입점사 A/S 티켓 내부 메모 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerUpdateVendorMemo()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  asControllerUpdateVendorMemo$Response(params: AsControllerUpdateVendorMemo$Params, context?: HttpContext): Observable<StrictHttpResponse<AsTicketDto>> {
    return asControllerUpdateVendorMemo(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 A/S 티켓 내부 메모 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerUpdateVendorMemo$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  asControllerUpdateVendorMemo(params: AsControllerUpdateVendorMemo$Params, context?: HttpContext): Observable<AsTicketDto> {
    return this.asControllerUpdateVendorMemo$Response(params, context).pipe(
      map((r: StrictHttpResponse<AsTicketDto>): AsTicketDto => r.body)
    );
  }

  /** Path part for operation `asControllerUpdateVendorResult()` */
  static readonly AsControllerUpdateVendorResultPath = '/api/v1/as/vendor/{clientWorkspaceId}/tickets/{ticketId}/result';

  /**
   * 입점사 A/S 티켓 작업 결과 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerUpdateVendorResult()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  asControllerUpdateVendorResult$Response(params: AsControllerUpdateVendorResult$Params, context?: HttpContext): Observable<StrictHttpResponse<AsTicketDto>> {
    return asControllerUpdateVendorResult(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 A/S 티켓 작업 결과 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerUpdateVendorResult$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  asControllerUpdateVendorResult(params: AsControllerUpdateVendorResult$Params, context?: HttpContext): Observable<AsTicketDto> {
    return this.asControllerUpdateVendorResult$Response(params, context).pipe(
      map((r: StrictHttpResponse<AsTicketDto>): AsTicketDto => r.body)
    );
  }

  /** Path part for operation `asControllerGetVendorTicketLogs()` */
  static readonly AsControllerGetVendorTicketLogsPath = '/api/v1/as/vendor/{clientWorkspaceId}/tickets/{ticketId}/logs';

  /**
   * 입점사 A/S 티켓 처리 로그 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerGetVendorTicketLogs()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerGetVendorTicketLogs$Response(params: AsControllerGetVendorTicketLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AsTicketLogDto>>> {
    return asControllerGetVendorTicketLogs(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 A/S 티켓 처리 로그 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerGetVendorTicketLogs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerGetVendorTicketLogs(params: AsControllerGetVendorTicketLogs$Params, context?: HttpContext): Observable<Array<AsTicketLogDto>> {
    return this.asControllerGetVendorTicketLogs$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AsTicketLogDto>>): Array<AsTicketLogDto> => r.body)
    );
  }

  /** Path part for operation `asControllerGetVendorWarning()` */
  static readonly AsControllerGetVendorWarningPath = '/api/v1/as/vendor/{clientWorkspaceId}/warning';

  /**
   * 입점사 티켓목록 상단 경고 데이터.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerGetVendorWarning()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerGetVendorWarning$Response(params: AsControllerGetVendorWarning$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'symptomCount'?: number;
'checkItemCount'?: number;
'shouldWarn'?: boolean;
'message'?: string;
}>> {
    return asControllerGetVendorWarning(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 티켓목록 상단 경고 데이터.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerGetVendorWarning$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerGetVendorWarning(params: AsControllerGetVendorWarning$Params, context?: HttpContext): Observable<{
'symptomCount'?: number;
'checkItemCount'?: number;
'shouldWarn'?: boolean;
'message'?: string;
}> {
    return this.asControllerGetVendorWarning$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'symptomCount'?: number;
'checkItemCount'?: number;
'shouldWarn'?: boolean;
'message'?: string;
}>): {
'symptomCount'?: number;
'checkItemCount'?: number;
'shouldWarn'?: boolean;
'message'?: string;
} => r.body)
    );
  }

  /** Path part for operation `asControllerGetVendorPendingCount()` */
  static readonly AsControllerGetVendorPendingCountPath = '/api/v1/as/vendor/{clientWorkspaceId}/pending-count';

  /**
   * 입점사 대기 A/S 티켓 수 조회 (RECEIVED 상태).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerGetVendorPendingCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerGetVendorPendingCount$Response(params: AsControllerGetVendorPendingCount$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'count'?: number;
}>> {
    return asControllerGetVendorPendingCount(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 대기 A/S 티켓 수 조회 (RECEIVED 상태).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerGetVendorPendingCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerGetVendorPendingCount(params: AsControllerGetVendorPendingCount$Params, context?: HttpContext): Observable<{
'count'?: number;
}> {
    return this.asControllerGetVendorPendingCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'count'?: number;
}>): {
'count'?: number;
} => r.body)
    );
  }

  /** Path part for operation `asControllerGetVendorSymptoms()` */
  static readonly AsControllerGetVendorSymptomsPath = '/api/v1/as/vendor/{clientWorkspaceId}/symptoms';

  /**
   * 입점사 증상 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerGetVendorSymptoms()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerGetVendorSymptoms$Response(params: AsControllerGetVendorSymptoms$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorSymptomDto>>> {
    return asControllerGetVendorSymptoms(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 증상 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerGetVendorSymptoms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerGetVendorSymptoms(params: AsControllerGetVendorSymptoms$Params, context?: HttpContext): Observable<Array<VendorSymptomDto>> {
    return this.asControllerGetVendorSymptoms$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VendorSymptomDto>>): Array<VendorSymptomDto> => r.body)
    );
  }

  /** Path part for operation `asControllerCreateVendorSymptom()` */
  static readonly AsControllerCreateVendorSymptomPath = '/api/v1/as/vendor/{clientWorkspaceId}/symptoms';

  /**
   * 입점사 증상 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerCreateVendorSymptom()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  asControllerCreateVendorSymptom$Response(params: AsControllerCreateVendorSymptom$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorSymptomDto>> {
    return asControllerCreateVendorSymptom(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 증상 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerCreateVendorSymptom$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  asControllerCreateVendorSymptom(params: AsControllerCreateVendorSymptom$Params, context?: HttpContext): Observable<VendorSymptomDto> {
    return this.asControllerCreateVendorSymptom$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorSymptomDto>): VendorSymptomDto => r.body)
    );
  }

  /** Path part for operation `asControllerDeleteVendorSymptom()` */
  static readonly AsControllerDeleteVendorSymptomPath = '/api/v1/as/vendor/{clientWorkspaceId}/symptoms/{symptomId}';

  /**
   * 입점사 증상 삭제(연쇄 소프트 삭제).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerDeleteVendorSymptom()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerDeleteVendorSymptom$Response(params: AsControllerDeleteVendorSymptom$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return asControllerDeleteVendorSymptom(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 증상 삭제(연쇄 소프트 삭제).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerDeleteVendorSymptom$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerDeleteVendorSymptom(params: AsControllerDeleteVendorSymptom$Params, context?: HttpContext): Observable<boolean> {
    return this.asControllerDeleteVendorSymptom$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `asControllerUpdateVendorSymptom()` */
  static readonly AsControllerUpdateVendorSymptomPath = '/api/v1/as/vendor/{clientWorkspaceId}/symptoms/{symptomId}';

  /**
   * 입점사 증상 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerUpdateVendorSymptom()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  asControllerUpdateVendorSymptom$Response(params: AsControllerUpdateVendorSymptom$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorSymptomDto>> {
    return asControllerUpdateVendorSymptom(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 증상 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerUpdateVendorSymptom$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  asControllerUpdateVendorSymptom(params: AsControllerUpdateVendorSymptom$Params, context?: HttpContext): Observable<VendorSymptomDto> {
    return this.asControllerUpdateVendorSymptom$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorSymptomDto>): VendorSymptomDto => r.body)
    );
  }

  /** Path part for operation `asControllerUpsertChecklist()` */
  static readonly AsControllerUpsertChecklistPath = '/api/v1/as/vendor/{clientWorkspaceId}/symptoms/{symptomId}/checklist';

  /**
   * 입점사 체크리스트 생성/수정(증상 1:1).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerUpsertChecklist()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  asControllerUpsertChecklist$Response(params: AsControllerUpsertChecklist$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorChecklistDto>> {
    return asControllerUpsertChecklist(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 체크리스트 생성/수정(증상 1:1).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerUpsertChecklist$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  asControllerUpsertChecklist(params: AsControllerUpsertChecklist$Params, context?: HttpContext): Observable<VendorChecklistDto> {
    return this.asControllerUpsertChecklist$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorChecklistDto>): VendorChecklistDto => r.body)
    );
  }

  /** Path part for operation `asControllerDeleteChecklist()` */
  static readonly AsControllerDeleteChecklistPath = '/api/v1/as/vendor/{clientWorkspaceId}/symptoms/{symptomId}/checklist';

  /**
   * 입점사 체크리스트 삭제(소프트).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerDeleteChecklist()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerDeleteChecklist$Response(params: AsControllerDeleteChecklist$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return asControllerDeleteChecklist(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 체크리스트 삭제(소프트).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerDeleteChecklist$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerDeleteChecklist(params: AsControllerDeleteChecklist$Params, context?: HttpContext): Observable<boolean> {
    return this.asControllerDeleteChecklist$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `asControllerGetChecklistItems()` */
  static readonly AsControllerGetChecklistItemsPath = '/api/v1/as/vendor/{clientWorkspaceId}/symptoms/{symptomId}/check-items';

  /**
   * 입점사 체크항목 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerGetChecklistItems()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerGetChecklistItems$Response(params: AsControllerGetChecklistItems$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorCheckItemDto>>> {
    return asControllerGetChecklistItems(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 체크항목 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerGetChecklistItems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerGetChecklistItems(params: AsControllerGetChecklistItems$Params, context?: HttpContext): Observable<Array<VendorCheckItemDto>> {
    return this.asControllerGetChecklistItems$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VendorCheckItemDto>>): Array<VendorCheckItemDto> => r.body)
    );
  }

  /** Path part for operation `asControllerCreateChecklistItem()` */
  static readonly AsControllerCreateChecklistItemPath = '/api/v1/as/vendor/{clientWorkspaceId}/symptoms/{symptomId}/check-items';

  /**
   * 입점사 체크항목 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerCreateChecklistItem()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  asControllerCreateChecklistItem$Response(params: AsControllerCreateChecklistItem$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorCheckItemDto>> {
    return asControllerCreateChecklistItem(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 체크항목 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerCreateChecklistItem$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  asControllerCreateChecklistItem(params: AsControllerCreateChecklistItem$Params, context?: HttpContext): Observable<VendorCheckItemDto> {
    return this.asControllerCreateChecklistItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorCheckItemDto>): VendorCheckItemDto => r.body)
    );
  }

  /** Path part for operation `asControllerDeleteChecklistItem()` */
  static readonly AsControllerDeleteChecklistItemPath = '/api/v1/as/vendor/{clientWorkspaceId}/check-items/{itemId}';

  /**
   * 입점사 체크항목 삭제(소프트).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerDeleteChecklistItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerDeleteChecklistItem$Response(params: AsControllerDeleteChecklistItem$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return asControllerDeleteChecklistItem(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 체크항목 삭제(소프트).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerDeleteChecklistItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  asControllerDeleteChecklistItem(params: AsControllerDeleteChecklistItem$Params, context?: HttpContext): Observable<boolean> {
    return this.asControllerDeleteChecklistItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `asControllerUpdateChecklistItem()` */
  static readonly AsControllerUpdateChecklistItemPath = '/api/v1/as/vendor/{clientWorkspaceId}/check-items/{itemId}';

  /**
   * 입점사 체크항목 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerUpdateChecklistItem()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  asControllerUpdateChecklistItem$Response(params: AsControllerUpdateChecklistItem$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorCheckItemDto>> {
    return asControllerUpdateChecklistItem(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 체크항목 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerUpdateChecklistItem$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  asControllerUpdateChecklistItem(params: AsControllerUpdateChecklistItem$Params, context?: HttpContext): Observable<VendorCheckItemDto> {
    return this.asControllerUpdateChecklistItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorCheckItemDto>): VendorCheckItemDto => r.body)
    );
  }

  /** Path part for operation `asControllerReorderChecklistItems()` */
  static readonly AsControllerReorderChecklistItemsPath = '/api/v1/as/vendor/{clientWorkspaceId}/symptoms/{symptomId}/check-items/reorder';

  /**
   * 입점사 체크항목 순서 재정렬.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `asControllerReorderChecklistItems()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  asControllerReorderChecklistItems$Response(params: AsControllerReorderChecklistItems$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return asControllerReorderChecklistItems(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 체크항목 순서 재정렬.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `asControllerReorderChecklistItems$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  asControllerReorderChecklistItems(params: AsControllerReorderChecklistItems$Params, context?: HttpContext): Observable<boolean> {
    return this.asControllerReorderChecklistItems$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
